import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

/**
 * @name Header
 * @function
 * @description Displays title of the page (e.g. Archives)
 * @returns {JSX}
 * @param {*} props 
 */
const Header = props => {
    return (
        <h1 className="page title">
            { props.title }
        </h1>
    )
}

Header.propTypes = {
    title: PropTypes.string
}

export default Header;